import React from "react";
import {
  FormControlLabel,
  Grid,
  makeStyles,
  Checkbox,
} from "@material-ui/core";
import ReportsCard from "./ReportsCard";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const minReportDate = new Date("2016-01-01");

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 10,
  },

  cardForm: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20,
  },

  datePicker: {
    minWidth: 130,
    width: "100%",
  },
}));

const MarcDateSelectionCard = ({ state, handleStateChange }) => {
  const classes = useStyles();
  return (
    <ReportsCard
      classes={{ root: classes.root }}
      cardLabel={
        "Providing date ranges will allow you to generate only MARC records that have" +
        " been added or updated during a specific time period. In addition to your email address, enter a" +
        " Start and End Date if your prefer only a subset of your records."
      }
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={2} classes={{ root: classes.cardForm }}>
          <Grid item xs={6}>
            <KeyboardDatePicker
              className={classes.datePicker}
              margin="normal"
              id="startDate"
              label="Start Date"
              format="MM/dd/yyyy"
              disableFuture={true}
              minDate={minReportDate}
              value={state.startDate}
              onChange={handleStateChange("startDate")}
              KeyboardButtonProps={{
                "aria-label": "start date",
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <KeyboardDatePicker
              className={classes.datePicker}
              margin="normal"
              id="endDate"
              label="End Date"
              format="MM/dd/yyyy"
              disableFuture={true}
              minDate={minReportDate}
              value={state.endDate}
              onChange={handleStateChange("endDate")}
              KeyboardButtonProps={{
                "aria-label": "start date",
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.includeDelete}
                  onChange={(e) =>
                    handleStateChange("includeDelete")(e.target.checked)
                  }
                  name="includeDelete"
                />
              }
              label="Include delete records"
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </ReportsCard>
  );
};

export default MarcDateSelectionCard;
